import { useListConsumerFamilyCauses } from '@givebacks/api/backer';

import {
  SearchableSelectSearch,
  useCreateSearchFn,
} from '../../../../../molecules/inputs/SearchableInputs';

const useSearchConsumerFamilyCausesFromSelect = (
  searches: SearchableSelectSearch,
  { familyId }: { familyId?: string }
) => {
  return useListConsumerFamilyCauses({
    familyId,
    queryOptions: {
      searches: searches,
    },
  });
};

// search function to search for available causes by name
const useSearchFamilyCausesFn = (familyId?: string) =>
  useCreateSearchFn({
    useSearchFn: useSearchConsumerFamilyCausesFromSelect,
    select: (data) =>
      data?.map((cause) => ({
        value: cause.uuid,
        label: cause.name || cause.uuid,
      })) || [],
    searchFields: ['name'],
    params: { familyId },
  });

export { useSearchFamilyCausesFn };
